import { Navigate } from 'react-router-dom';

const UsersManage = () => <Navigate to="/settings?tab=users" replace />;

export default UsersManage;
